import React, { useState } from 'react';
import { Tooltip, Button, Switch, Space } from 'antd';
import { FilterOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { buildFilterSelector, filterDrawerTitleSelector } from '@store/trends/base/selectors';
import { FilterBarFooter, StyledDrawer } from './styled';
import FilterBar from './FilterBar';
import { applyFilter, updateRule, removeRule, resetFilter } from '@store/trends/base/actions';
import FilterBarAdvanced from './FilterBarAdvanced';
import { useHistory } from 'react-router-dom';
import { tid } from '@utils/test';

function FilterBuilder({ onToggle, visible, disabled }) {
  const dispatch = useDispatch();
  const generatedFilter = useSelector(buildFilterSelector);
  const [advanced, setAdvanced] = useState(true);
  const history = useHistory();
  const title = useSelector(filterDrawerTitleSelector);

  const { rule = [] } = generatedFilter;

  const handleClick = () => {
    onToggle(true);
    // dispatch(initRule()); // TODO: confirm init value scenario and drilldown
  };

  const handleOk = () => {
    dispatch(applyFilter({ history }));
    handleCancel();
  };

  const handleCancel = () => {
    onToggle(false);
    dispatch(resetFilter());
  };

  const onSwitchChange = (checked: boolean) => {
    setAdvanced(checked);
  };

  return (
    <>
      <Button onClick={handleClick} disabled={disabled} icon={<FilterOutlined />}>
        Advanced Filter
      </Button>
      <StyledDrawer
        title={
          <Space style={{ alignItems: 'baseline' }}>
            <h3>{title}</h3>
            <Switch
              checkedChildren="Advanced"
              unCheckedChildren="Basic"
              onChange={onSwitchChange}
              defaultChecked
              {...tid('filter-drawer-switch')}
            />
          </Space>
        }
        placement="top"
        closable={true}
        onClose={handleCancel}
        open={visible}
        key="filter-builder"
        mask={false}
        height={200}
        zIndex={999}
        footer={
          <FilterBarFooter {...tid('filter-drawer-footer')}>
            <Button type="primary" onClick={handleOk}>
              Apply
            </Button>
            <Button onClick={handleCancel}>Cancel</Button>
          </FilterBarFooter>
        }
      >
        <div {...tid('filter-drawer-body')}>
          {rule.length === 0 ? (
            <p>Click on a row to add to the filter</p>
          ) : advanced ? (
            <FilterBarAdvanced rules={rule} removeRule={removeRule} updateRule={updateRule} />
          ) : (
            <FilterBar rules={rule} removeRule={removeRule} />
          )}
        </div>
      </StyledDrawer>
    </>
  );
}

export default FilterBuilder;
